import { AuthenticationProvider } from '~/providers/AuthenticationProvider';
import { ToastViewport } from './components/ToastViewport/ToastViewport';
import { QueryProvider } from '~/providers/QueryProvider';
import { Analytics } from '@vercel/analytics/react';
import { RouterProvider } from 'react-router';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { router } from './router';

import './styles/variables.css';
import './styles/reset.css';
import './styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryProvider>
      <AuthenticationProvider>
        <RouterProvider router={router} />
      </AuthenticationProvider>
    </QueryProvider>

    <ToastViewport />
    {/* The React entry only reads REACT_APP_* env vars, which Vite doesn't expose */}
    <Analytics
      basePath={import.meta.env.VITE_VERCEL_OBSERVABILITY_BASEPATH}
      configString={import.meta.env.VITE_VERCEL_OBSERVABILITY_CLIENT_CONFIG}
    />
  </StrictMode>
);
